import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiHandlerService } from '../api-handler.service';
declare var $: any;
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  private apiUrl = `${environment.apiUrl}/contact`;
  constructor(private apiHandler: ApiHandlerService) { }
  public email = "";
  public name = "";
  public contact = "";
  public msg = "";
  public purpose = "";
  public showValidations = false;
  ngOnInit() {

  }
  postContactUsForm() {
    if (this.email && this.purpose && this.name) {
      this.showValidations = false;
      this.apiHandler.post(this.apiUrl, { email: this.email, purpose: this.purpose, msg: this.msg, name: this.name, contact: this.contact }).subscribe(result => {
        console.log(result);
        $('#thanks-modal').modal('show');
        this.resetInputs()
      })
    }else{
      this.showValidations = true;
    }
  }
  resetInputs() {
    this.email = "";
    this.name = "";
    this.purpose = "";
    this.msg = "";
    this.contact  = "";
  }
}
